export interface SelectableColorOption {
  value: string;
  label: string;
}

export const SELECTABLE_COLOR_OPTIONS: SelectableColorOption[] = [
  { value: "#F7D252", label: "Yellow" },
  { value: "#FFB067", label: "Orange" },
  { value: "#FF8F8F", label: "Coral" },
  { value: "#FFBEF4", label: "Pink" },
  { value: "#A584F2", label: "Purple" },
  { value: "#94A3B8", label: "Blue Grey" },
  { value: "#62A4D8", label: "Blue" },
  { value: "#55E0D6", label: "Teal" },
  { value: "#42CB84", label: "Green" },
  { value: "#0F7B43", label: "Dark Green" },
];

export const DEFAULT_SELECTABLE_COLOR = SELECTABLE_COLOR_OPTIONS[0]?.value ?? "#F7D252";
